module.exports = __webpack_public_path__ + "assets/img/ser_119019.f3e692e2.png";